export default "__VITE_ASSET__DqnnoCwh__"